import {DeviceConsumablePricingItem} from "./device-consumable-pricing-item";

export class DeviceConsumableWithSuppPricingItem extends DeviceConsumablePricingItem {
    public additionalConsumablePrice?: string;


}
